export const APP_NAME = import.meta.env.VITE_APP_NAME;
export const APP_ENV = import.meta.env.VITE_APP_ENV;

// temporal
export const API_HOST = import.meta.env.VITE_API_HOST;
export const API_PATH = import.meta.env.VITE_API_PATH;
export const API_ENDPOINT = API_HOST + API_PATH;

// chat service
export const CHAT_SERVICE_HOST = import.meta.env.VITE_CHAT_SERVICE_HOST;
export const CHAT_SERVICE_PATH = import.meta.env.VITE_CHAT_SERVICE_PATH;
export const CHAT_SERVICE_ENDPOINT = CHAT_SERVICE_HOST + CHAT_SERVICE_PATH;

export const AUTH_TOKEN_KEY = import.meta.env.VITE_AUTH_TOKEN_KEY;
export const CUSTOMER_ID_KEY = import.meta.env.VITE_CUSTOMER_ID_KEY;

export const WORKFLOW_ID_KEY = import.meta.env.VITE_WORKFLOW_ID_KEY;

export const LANGUAGE_KEY = import.meta.env.VITE_LANGUAGE_KEY;

export const CUSTOMER_API_SECRET_TOKEN = import.meta.env.VITE_CUSTOMER_API_SECRET_TOKEN;
export const CUSTOMER_HOST = import.meta.env.VITE_CUSTOMER_HOST;
export const CUSTOMER_PATH = import.meta.env.VITE_CUSTOMER_PATH;
export const CUSTOMER_ENDPOINT = CUSTOMER_HOST + CUSTOMER_PATH;

export const DEV_APP_VERSION = import.meta.env.VITE_DEV_APP_VERSION;
export const DEV_APP_BUILD_NUMBER = import.meta.env.VITE_DEV_APP_BUILD_NUMBER;
export const DEV_CLIENT_OS = import.meta.env.VITE_DEV_CLIENT_OS;
export const DEV_DEVICE_ID = import.meta.env.VITE_DEV_DEVICE_ID;

export const APP_URL = import.meta.env.VITE_APP_URL;

export const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;
// soketi config
export const PUSHER_APP_KEY = import.meta.env.VITE_PUSHER_APP_KEY;
export const PUSHER_HOST = import.meta.env.VITE_PUSHER_HOST;
export const PUSHER_PORT = import.meta.env.VITE_PUSHER_PORT;
export const PUSHER_SEHCME = import.meta.env.VITE_PUSHER_SCHEME;
export const PUSHER_TLS = import.meta.env.VITE_PUSHER_SCHEME === 'https';
export const PUSHER_CLUSTER = import.meta.env.VITE_PUSHER_CLUSTER;

export const FIND_AGENT_TIMEOUT_MS = 60_000;
export const FIND_AGENT_TIMEOUT_SECONDS = 60;
